import React, { useState, useEffect, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { loadImage } from '../motionImagesWithScroll/MotionImagesWithScroll';
// const data = [
//   'Family',
//   'J’s',
//   'Hiking',
//   'Hip hop',
//   'Technology',
//   'Sport',
//   'Movie',
//   'Animation',
//   'Programming',
//   'Cooking',

// ];

const BeyondCode: React.FC<{
  windowSize: {
    width: number;
    height: number
  };
}> = ({ windowSize }) => {

  const [imgsLoaded, setImgsLoaded] = useState<boolean>(false);

  const [selected, setSelected] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const dataLength = 8;
  const space = 80;

  const width =
    windowSize.width > 2000 ? (windowSize.width / 5) :
      windowSize.width > 1500 ? (windowSize.width / 4) :
        windowSize.width > 1100 ? (windowSize.width / 3) :
          windowSize.width > 700 ? (windowSize.width / 2.5) :
            windowSize.width > 450 ? windowSize.width - 200 :
              windowSize.width - 100;
  //const width = windowSize.width - 200 > windowSize.height ? windowSize.height - 300 : windowSize.width - 200;

  const arrowSize = width;
  //const arrowSize = windowSize.width > ((width * 3) + space) ? width : (windowSize.width - width + space) / 2;

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setSelected(prev => (prev === dataLength - 1 ? 0 : prev + 1));
    }, 2000);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [selected]);

  useEffect(() => {
    if (!imgsLoaded) {
      const IMAGES = [];
      for (let i = 0; i < dataLength; i++) {
        IMAGES.push({ url: process.env.PUBLIC_URL + `/beyondCode/s${i}.jpg` });
      }
      Promise.all(IMAGES.map((image) => loadImage(image)))
        .then(() => setImgsLoaded(true))
        .catch((err) => console.error('Failed to load images', err));
    }
  }, [imgsLoaded]);

  const htmlItem = (id: number, opacity: number, core: boolean = true) => {
    return <Box style={{
      position: 'relative', width: (core ? width : arrowSize), height: width,
      padding: '10px',
      cursor: (core ? 'default' : 'pointer'), opacity: opacity,
    }} onClick={() => !core && setSelected(id)} >
      <img
        style={{ width: (core ? width : arrowSize), height: width, objectFit: 'cover' }}
        src={process.env.PUBLIC_URL + `beyondCode/s${id}.jpg`}
        alt={`Interest: ${[id]}`}
      />
      {/* {core && <Box sx={{
        position: 'absolute',
        top: '10Px',
        left: '10Px',
        backgroundColor: 'var(--backColorShadow)',
        borderRadius: '0 0 20px 0',
      }} >
        <Typography variant="body1" sx={{
          fontWeight: 'bold',
          margin: '0 20px',
        }} >{data[id]}</Typography>
      </Box>} */}
    </Box>;
  }

  return (
    <Box
      component="section"
      sx={{
        overflowX: 'hidden',
        display: "flex",
        flexDirection: "column",
      }}>
      <Box
        sx={{
          zIndex: '1',
          //backgroundColor: '#dde3e1',
          backgroundColor: '#c4d0ce',
          // padding: '10px 0px',
        }}>

        <Typography variant="h4" align="center" sx={{ fontWeight: "bold", mt: 4, mb: 4 }} >
          Beyond Code {!imgsLoaded && <CircularProgress />}
        </Typography>

        {imgsLoaded && <Box display='flex' justifyContent='center' alignItems='center' sx={{ mb: 4 }}
        >
          {htmlItem((selected - 2 + dataLength) % dataLength, 1, false)}
          {htmlItem((selected - 1 + dataLength) % dataLength, 1, false)}
          {htmlItem(selected, 1)}
          {htmlItem((selected + 1) % dataLength, 1, false)}
          {htmlItem((selected + 2) % dataLength, 1, false)}
        </Box>}

        {/* <Box display='flex' justifyContent='center' alignItems='center' sx={{ mb: 4 }} gap={0} >
          {data.map((item, index) =>
            <IconButton key={index} aria-label="delete" onClick={() => setSelected(index)} color="default" sx={{ p: 0.3 }}>
              <CircleIcon color={index === selected ? "success" : "disabled"} />
            </IconButton>
          )}
        </Box> */}

      </Box>
    </Box>
  );
};

export default BeyondCode;